<ng-container *ngIf="displayError">
  {{ errorMsg | translate }}
</ng-container>
